export enum SmartButtonSubType {
    onPause = 'diesel.common.smart_button.pause',
    onCancel = 'diesel.common.smart_button.cancel',
    onPlay = 'diesel.common.smart_button.play',
    onSettings = 'diesel.common.smart_button.settings'
}

export default SmartButtonSubType;
